var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteCheck = function SvgWhiteCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.144.473a.64.64 0 0 1 .916 0c.25.254.253.662.01.919L4.895 7.509l-.016.018a.64.64 0 0 1-.916 0L.815 4.336a.66.66 0 0 1 0-.928.64.64 0 0 1 .916 0L4.4 6.115 9.128.493z"
  })));
};
export default SvgWhiteCheck;